import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi, tokenManager } from '../../services/api';

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authApi.login(email, password);
      tokenManager.set(res.data.data.token, res.data.data.user);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Email atau password salah.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #081626 0%, #00CFFF 50%, #66E0FF 100%)' }}>
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-3">
            <img src={require('../../logo.png')} alt="Logo" className="h-20 w-auto" />
          </div>
          <h2 className="text-xl font-bold text-gray-800">Dev-Sas</h2>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 rounded-xl p-3 mb-4 text-sm">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:border-transparent" style={{ '--tw-ring-color': '#66E0FF' }} placeholder="admin@klinnovac.com" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:border-transparent outline-none" style={{ '--tw-ring-color': '#66E0FF' }} placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} className="w-full text-white font-semibold py-3 rounded-xl transition-all disabled:opacity-50 hover:shadow-lg" style={{ background: 'linear-gradient(135deg, #00CFFF, #66E0FF)', color: '#081626' }}>
            {loading ? 'Memproses...' : 'Masuk'}
          </button>
        </form>
        <p className="text-center text-xs text-gray-400 mt-6">
          Default: admin@klinnovac.com / password123
        </p>
      </div>
    </div>
  );
}